<template>
  <div class="bulk-tags-wrapper" v-show='showing'>
    <form>
      <div class="search-wrapper">
        <input v-model='q' @keydown.enter='addTag()' type='text' :placeholder='qPlaceholder' class='form-control' />
      </div>

      <div class="selectable-tags-wrapper" v-scroll='scroll'>
        <div v-if="q.length > 0 && !loading && !isExactMatch" @click="addTag()" class="selectable-tag">
          <b><i class="fa fa-plus"></i> {{ $t('tags_manager.create_tag') }}:</b> {{ q }}
        </div>

        <div v-for="tag in tags" @click="toggleTag(tag)" :class="{ selected: selectedTags[tag.id] }" class="selectable-tag" :key='tag.id'>
          <i class="fa fa-tag"></i>
          {{ tag.name }}
        </div>

        <div v-show='loading'>
          {{ $t('shared.loading') }}
        </div>
      </div>

      <div @click="submit" class="btn btn-primary btn-sm">
        {{ $t('products.list.submit') }}
      </div>

      <div @click='showing = false' class="btn btn-outline-primary btn-sm">
        {{ $t('products.list.cancel') }}
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        q: '',
        page: 0,
        loading: false,
        showing: false,
        noMoreResults: false,
        recordIds: [],
        folderIds: [],
        contactIds: [],
        tags: [],
        selectedTags: {},
      }
    },
    created() {
      this.debouncedLoadMoreOptions = this._debounce(() => this.loadMoreOptions(), 500)
    },
    watch: {
      q() {
        this.page = 0
        this.tags = []
        this.loading = true
        this.noMoreResults = false
        this.debouncedLoadMoreOptions()
      }
    },
    computed: {
      qPlaceholder() {
        return this.tags.length > 0 ? this.$t('tags_manager.search_tag') : this.$t('tags_manager.create_a_tag')
      },
      isExactMatch() {
        return this.tags.some(t => t.name.toLowerCase() == this.q.toLowerCase())
      },
    },
    methods: {
      open(folders, records) {
        this.page = 0
        this.loadMoreOptions()

        this.folderIds = (folders || []).map(f => f.id)
        this.recordIds = (records || []).map(r => r.id)
        this.selectedTags = {}

        this.showing = true
      },
      openContacts(contacts){
        this.page = 0
        this.loadMoreOptions()

        this.contactIds = (contacts || []).map(c => c.id)
        this.selectedTags = {}

        this.showing = true
      },
      addTag() {
        this.store.createTag({ name: this.q }).then(({data}) => {
          this.q = ''
          this.page = 0
          this.loadMoreOptions()
          this.toggleTag(data)
          this.$toastr.success(this.$t('products.list.tag_created'))
        })
      },
      toggleTag(tag) {
        if (this.selectedTags[tag.id])
          return this.$delete(this.selectedTags, tag.id)

        this.selectedTags = Object.assign({}, this.selectedTags, { [tag.id]: tag })
      },
      submit(e) {
        const params = { tag_ids: Object.keys(this.selectedTags) }
        let folderPromise = null
        let recordPromise = null

        if (this.folderIds.length > 0)
          folderPromise = this.axios.post("/connected_tags/", Object.assign({}, params, { folder_ids: this.folderIds }))

        if (this.recordIds.length > 0)
          recordPromise = this.axios.post("/connected_tags/", Object.assign({}, params, { record_ids: this.recordIds }))

        if (this.contactIds.length > 0)
          recordPromise = this.axios.post("/connected_tags/", Object.assign({}, params, { contact_ids: this.contactIds }))

        Promise.allSettled([folderPromise, recordPromise]).then(() => {
          this.store.sendMetrics({name: 'bulk_connect_tag_with_resource', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
          this.close()
        })
      },
      loadMoreOptions() {
        this.loading = true

        this.listStore.getTags({ q: this.q, page: this.page + 1 }).then((data) => {
          this.loading = false
          this.page = data.meta.page

          if (data.data.length > 0)
            this.tags = this.tags.concat(data.data)
          else
            this.noMoreResults = true
        })
      },
      scroll(e) {
        if (this.loading || this.noMoreResults)
          return

        if (e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight) > 0.8) {
          this.loadMoreOptions()
        }
      },
    }
  }
</script>

<style lang="sass" scoped>
  form
    position: absolute
    top: 46px
    right: 0
    background: #ffffff
    width: 250px
    border: 1px solid #c4c4c4
    border-radius: 3px
    padding: 5px
    z-index: 100
    .btn
      margin-top: 15px
      float: right
    .btn-outline-primary
      margin-right: 10px
    .bulk-tags-wrapper
      width: 280px
      position: relative
    .selectable-tags-wrapper
      text-align: left
</style>
